<template>
  <v-switch
    :input-value="value"
    @change="onChange"
    color="#80CBC4"
    class="ma-0 pa-0"
    inset
    dense
    hide-details
    x-small
  ></v-switch>
</template>

<script>
export default {
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    value: Boolean,
  },
  methods: {
    onChange(value) {
      this.$emit("change", !!value);
    },
  },
};
</script>

<style></style>
